import Vue from 'vue'
import VueRouter from 'vue-router'
import Logout from '../views/Logout.vue'
import SelectStore from '../views/SelectStore.vue'
import Home from '../views/Home.vue'
import Callback from '../views/Callback.vue'
import Redirect from '../views/Redirect.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/select-store',
    name: 'selectStore',
    component: SelectStore
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback
  },
  {
    path: '/redirect',
    name: 'redirect',
    component: Redirect
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (to.name == 'home') {
    const callbackURI = to.query.callback_uri
    const hash = to.hash
    if (callbackURI) {
      const uri = `${callbackURI}${hash}`
      window.localStorage.setItem('callback_uri', uri)
    }
  } 
  
  if(to.name == 'callback' || to.name == 'redirect') {
    next()
  } else if (router.app.$auth.isAuthenticated()) {
    next()
  } else { // trigger auth0 login
    router.app.$auth.login()
  }
})

export default router
